import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import * as moment from 'moment';

import { ChecklistResponseModel } from '../../model/question_response.model copy';
import { SchedulingDto } from '../../model/ms_scheduling_dto';
import { ChecklistModel } from '../../model/checklist.model';
import { RecurrenceDto } from '../../model/ms_recurrence';

@Component({
	styles: [''],
	selector: 'app-scheduling-filter-query',
	templateUrl: './scheduling-filter-query.html',
	// changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SchedulingQueryComponent {
	@Output() errorChange = new EventEmitter<any>();
	@Output() hasChange = new EventEmitter<any>();
	
	@Input() dayEvents: any[] = null;
	@Input() dayEvent: any = null;
	@Input() selectKey = '';
	
	@Input() recurrenceFormOptions: any = {};
	@Input() calendars: any[] = [];
	@Input() recurrenceOptions = [];
	@Input() checklistOptions = [];
	@Input() responseOptions = [];
	@Input() userOptions = [];

	@Input() recurrenceForm = new RecurrenceDto();
	@Input() recurrence = null;
	@Input() loading = false;

	// LOCAL RESPONSES (Selected)
	@Input() checklist: ChecklistModel = new ChecklistModel();
	@Input() response: ChecklistResponseModel = null;
	@Input() calendar = this.calendars[0] || '';
	@Input() checklists: any[] = [];
	@Input() responses: any[] = [];
	@Input() users: any[] = []
	@Input() init_date = null;
	@Input() end_date = null;
	@Input() repeat = false;
	@Input() user = null;

	onSwitchChange({ checked }) {
		this.repeat = checked;
	}

	// validations
	saveEvent() {
		// if (!this.recurrence) {
		// 	return this.errorChange.emit({ message: 'select_o:recurrence' });
		// }

		if (!this.users.length) {
			return this.errorChange.emit({ message: 'select_o:user' });
		}

		if (!this.calendar) {
			return this.errorChange.emit({ message: 'select_o:calendar' });
		}

		if (!this.checklist || !this.checklist.id || !this.checklist.name) {
			return this.errorChange.emit({ message: 'select_o:checklist' });
		}

		const today = new Date();
		today.setHours(0, 0, 0, 0);
		const nowTime = today.getTime();
		const end_date = new Date(this.end_date).getTime();
		const init_date = new Date(this.init_date).getTime();

		if (!this.recurrence && (!init_date || init_date < nowTime))
		return this.errorChange.emit({ message: 'invalid:from' });
		if (!this.recurrence && (!end_date || end_date < nowTime))
		return this.errorChange.emit({ message: 'invalid:until' });

		if (this.recurrence && this.recurrenceForm) {
			const startDate = new Date(this.recurrenceForm.range.startDate).getTime();
			const endDate = new Date(this.recurrenceForm.range.endDate).getTime();

			if (!this.recurrenceForm.range.type)
			return this.errorChange.emit({ message: 'select_o:range_type' });

			if (!startDate || startDate < nowTime)
			return this.errorChange.emit({ message: 'invalid:start_date' });

			if (this.recurrenceForm.range.type == 'endDate' && !endDate)
			return this.errorChange.emit({ message: 'invalid:end_date' });

			if (['absoluteYearly', 'relativeYearly'].includes(this.recurrence)) {
				if (!this.recurrenceForm.pattern.month)
				return this.errorChange.emit({ message: 'invalid:month' });
			}

			if (['absoluteMonthly', 'absoluteYearly'].includes(this.recurrence)) {
				if (!this.recurrenceForm.pattern.dayOfMonth)
				return this.errorChange.emit({ message: 'invalid:day_of_month' });
			}

			if (['weekly', 'relativeMonthly', 'relativeYearly'].includes(this.recurrence)) {
				if (!this.recurrenceForm.pattern.daysOfWeek || !this.recurrenceForm.pattern.daysOfWeek.length)
				return this.errorChange.emit({ message: 'select_o:days_of_week' });
			}
		}

		const event_dto = {
			recurrence: this.formatRecurrence(),

			checklist_name: this.checklist.name,

			attendees: this.users.map(
				(user) => ({
					type: 'required',
					emailAddress: {
						id: user.id,
						name: user.name,
						address: user.email.address,
					}
				})
			),
			// user_name: this.users[0].name,
			// user_email: this.users[0].email.address,

			endTime: moment(this.end_date).format(),
			startTime: moment(this.init_date).format(),

			calendar_id: this.dayEvent && this.dayEvent.calendar_id || this.calendar,
		} as SchedulingDto;

		this.hasChange.emit({ action: 'create', event_dto });
	}

	formatRecurrence() {
		this.recurrenceForm.pattern.type = this.recurrence;
		// this.recurrenceForm = new RecurrenceDto(this.recurrenceForm);

		if (!this.recurrence || !this.recurrenceForm) return null;
	
		const base = new RecurrenceDto(this.recurrenceForm);
		const { pattern, range } = this.recurrenceForm || {} as RecurrenceDto;
	
		// RANGE VALIDATIONS	
		if (range.type) {
			base.range.startDate = moment(range.startDate).format('YYYY-MM-DD');
		}

		if (range.type == 'numbered') {
			base.range.numberOfOccurrences = range.numberOfOccurrences || 1;
			// base.range.startDate = moment(range.startDate).format('YYYY-MM-DD');
		}

		// Need be formated to this pattern
		if (range.type == 'endDate' && range.endDate) {
			base.range.endDate = moment(range.endDate).format('YYYY-MM-DD');
			// base.range.startDate = moment(range.startDate).format('YYYY-MM-DD');
		}
	
		// PATTERN VALIDATIONS
		if (this.recurrence && (!pattern.interval || pattern.interval < 1)) {
			base.pattern.interval = 1; // always required
		} else if (this.recurrence) {
			base.pattern.interval = pattern.interval;
		}

		if (this.recurrence == 'weekly') {
			base.pattern.firstDayOfWeek = 'sunday';
			base.pattern.daysOfWeek = pattern.daysOfWeek.filter(v => v);
		}
	
		if (this.recurrence == 'absoluteMonthly' || this.recurrence == 'absoluteYearly') {
			base.pattern.dayOfMonth = pattern.dayOfMonth;
		}
	
		if (this.recurrence == 'relativeMonthly' || this.recurrence == 'relativeYearly') {
			base.pattern.daysOfWeek = pattern.daysOfWeek.filter(v => v);
			if (pattern.index) base.pattern.index = pattern.index;
		}
	
		if (this.recurrence == 'absoluteYearly' || this.recurrence == 'relativeYearly') {
			base.pattern.month = pattern.month;
		}
	
		return this.removeNullFields(base);
	}

	removeNullFields(obj) {
		if (Array.isArray(obj)) {
			return obj
				.map(this.removeNullFields)
				.filter(item => item !== null && item !== undefined);
		} else if (typeof obj === 'object' && obj !== null) {
			return Object.entries(obj).reduce((acc, [key, value]) => {
				const cleanedValue = this.removeNullFields(value);
				if (cleanedValue !== null && cleanedValue !== undefined) {
					acc[key] = cleanedValue;
				}
				return acc;
			}, {});
		} else {
			return obj;
		}
	}

	onRecurrenceChange(newType: string) {
		this.recurrenceForm.pattern.type = this.recurrence;
		this.recurrenceForm = new RecurrenceDto(this.recurrenceForm);
	
		if (newType == 'weekly' || newType == 'relativeMonthly' || newType == 'relativeYearly') {
			this.recurrenceForm.pattern.daysOfWeek = [];
		}
	
		if (newType == 'relativeMonthly' || newType == 'relativeYearly') {
			this.recurrenceForm.pattern.index = 'first';
		}
	
		if (newType == 'absoluteMonthly' || newType == 'absoluteYearly') {
			this.recurrenceForm.pattern.dayOfMonth = null;
		}
	
		if (newType == 'absoluteYearly' || newType == 'relativeYearly') {
			this.recurrenceForm.pattern.month = null;
		}
	}	

	updateEvent() {
		const event_dto = {
			id: this.dayEvent && this.dayEvent.id,
			response_id: this.response && this.response.id,

			// init_date: moment(this.init_date).format(),
			// end_date: moment(this.end_date).endOf('day').format(),
		};

		this.hasChange.emit({ action: 'update', event_dto });
	}

	cancelEvent() {
		const event_dto = {
			id: this.dayEvent && this.dayEvent.id,
		};

		this.hasChange.emit({ action: 'cancel', event_dto });
	}

	resetEvent() {
		this.hasChange.emit({ action: 'reset' });
	}

}

/*
MS ERRORS AND FIXES
0 - were unable to deserialize
	0.1 - conflito de tipos, do 'range' ou 'pattern'
1 - StartDateV2 should be earlier or equal to EndDateV2.
  1.1 - Pode ser literalmente oq está escrito, ou algum field obrigatorio faltando, como o type:'numbered'
2 - Cannot submit message.
	2.1 Cota excedida
*/ 



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/component/scheduling-filter-query/scheduling-filter-query.ts